/**
 * Menu data till we have a backend
 */
export const menu = [
    {
      id: 1,
      name: 'Combos',
      description: 'Combo includes small fry and 24 oz drink',
      items: [
        { 
          id: 1, 
          name: 'Cheese Burger', 
          description: '1/3 LB PATTY, AMERICAN CHEESE, FRY SAUCE, LETTUCE, TOMATO, PICKLES', 
          price: '$8.99', 
          comboPrice: '$14.97',
          image: '/images/menu/single-burger-with-cheese-300x300.jpg' 
        },
        { 
          id: 2, 
          name: 'DBL. Cheese Burger', 
          description: '(2) 1/3 LB PATTIES, AMERICAN CHEESE, FRY SAUCE, LETTUCE, TOMATO, PICKLES', 
          price: '$10.99', 
          comboPrice: '$16.97',
          image: '/images/menu/double-burger-with-cheese-300x300.jpg' 
        },
        { 
          id: 3, 
          name: 'Bacon Cheese Burger', 
          description: '1/3 LB PATTY, AMERICAN CHEESE, BACON, FRY SAUCE, LETTUCE, TOMATO, PICKLES', 
          price: '$9.99', 
          comboPrice: '$15.97',
          image: '/images/menu/single-burger-with-cheese-and-bacon-300x300.jpg' 
        },
        { 
          id: 4, 
          name: 'DBL. Bacon Cheese Burger', 
          description: '(2) 1/3 LB PATTIES, AMERICAN CHEESE, BACON, FRY SAUCE, LETTUCE, TOMATO, PICKLES', 
          price: '$11.99', 
          comboPrice: '$17.97',
          image: '/images/menu/double-burger-cheese-and-bacon-300x300.jpg' 
        },
        { 
          id: 5, 
          name: 'Pastrami Cheese Burger', 
          description: '1/3 LB PATTY, SWISS CHEESE, PASTRAMI, FRY SAUCE, LETTUCE, TOMATO, PICKLES', 
          price: '$9.99', 
          comboPrice: '$15.97',
          image: '/images/menu/pastrami-burger-single-300x300.jpg' 
        },
        { 
          id: 6, 
          name: 'DBL. Pastrami Cheese Burger', 
          description: '(2) 1/3 LB PATTIES, SWISS CHEESE, PASTRAMI, FRY SAUCE, LETTUCE, TOMATO, PICKLES', 
          price: '$11.99', 
          comboPrice: '$17.97',
          image: '/images/menu/pastrami-burger-double-300x300.jpg' 
        },
        { 
          id: 7, 
          name: 'Chicken Sandwich', 
          description: 'CHICKEN, FRY SAUCE, LETTUCE, TOMATO, PICKLES', 
          price: '$8.99', 
          comboPrice: '$14.97',
          image: '/images/menu/chicken-sandwich-300x300.jpg' 
        },
      ],
      additionalInfo: 'ADDITIONAL TOPPINGS AVAILABLE: GRILLED ONIONS, GRILLED MUSHROOMS, JALAPENOS.'
    },
    {
      id: 2,
      name: 'Sides',
      description: '',
      items: [
        { id: 1, name: 'Small Home-Cut Fries', description: '1 SAUCE', price: '$3.99', image: '/images/menu/small-fry-300x300.jpg' },
        { id: 2, name: 'Regular Home-Cut Fries', description: '2 SAUCES', price: '$6.49', image: '/images/menu/large-fry-300x300.jpg' },
        { id: 3, name: 'Garlic Cheese Curd', description: 'MARINARA', price: '$7.49', image: '/images/menu/cheese-curds-300x300.jpg' },
        { id: 4, name: 'Onion Rings', description: '2 SAUCES', price: '$6.49', image: '/images/menu/onion-rings-300x300.jpg' },
      ],
    },
    {
      id: 3,
      name: 'Kids Meals',
      description: 'INCLUDES: KIDS FRY, 12 OZ. FOUNTAIN DRINK',
      price: '$6.49',
      items: [
        { id: 1, name: 'Kids Slider Burger', description: 'FRY SAUCE, PICKLES', price: '$6.49', image: '/images/menu/kids-burger-300x300.jpg' },
        { id: 2, name: 'Mini Corndogs', description: '', price: '$6.49', image: '/images/menu/corn-dogs-with-fries-300x300.jpg' },
        { id: 3, name: 'Chicken Nuggets', description: '', price: '$6.49', image: '/images/menu/kids-chicken-nugget-and-fry-300x300.jpg' },
      ],
    },
    {
      id: 4,
      name: 'Other Items',
      description: '',
      items: [
        { id: 1, name: 'Chicken Strip Basket', description: 'THREE CHICKEN STRIPS AND FRIES', price: '$11.49', image: '/images/menu/chicken-strips-and-fry-300x300.jpg' },
        { id: 2, name: 'Beef Hot Dog', description: 'KETCHUP, MUSTARD AND RELISH', price: '$5.49', image: '' },
        { id: 3, name: 'BLT Sandwich', description: 'MAYO, BACON, LETTUCE, TOMATO', price: '$6.99', image: '/images/menu/blt-sandwich-300x300.jpg' },
        { id: 4, name: 'Grilled Cheese', description: '', price: '$5.49', image: '/images/menu/grilled-cheese-300x300.jpg' },
        {
          id: 5,
          name: "BB Strawberry Salad",
          description: 'Spring mix and lettuce blend, smoked bacon crumble, strawberries, mozzarella cheese, cherry tomatoes',
          price: '$9.99',
          image: '/images/menu/salad-white-background-300x300.jpg',
          addOns: [
            { name: 'Add grilled or fried chicken', price: '$4.00' }
          ],
          options: [
            { name: 'Dressing', choices: ['Ranch', 'Raspberry vinaigrette'] }
          ]
        },
      ],
    },
    {
      id: 5,
      name: 'Dipping Sauces',
      description: 'EXTRA SAUCES 45¢',
      flavors: [{
        name: 'Available Sauces',
        options: [
          'BBQ Sauce', 'Mustard', 'Fry Sauce', 'Ranch', 'Ketchup', 
          'Sweet / Sour', 'Mayo', 'Marinara'
        ]
      }],
    },
    {
      id: 6,
      name: 'Shakes',
      description: '',
      items: [
        { id: 1, name: 'Small Shake', description: '', price: '$5.99', image: '/images/menu/raspberry-shakes-2-sizes-300x300.jpg' },
        { id: 2, name: 'Regular Shake', description: '', price: '$6.99', image: '/images/menu/shakes-3-300x300.jpg' },
      ],
      flavors: [
        { 
          name: 'Shake Flavors',
          options: [
            "Famous Raspberry™","Banana", "Blackberry", "Brownie", "Butterfinger", "Caramel", "Cashew", 
            "Cheesecake", "Chocolate Chip", "Cookie Dough", "Fudge", "Heath", "Lime", 
            "M&M", "Malt", "Marshmallow", "Mint", "Mint Choc. Chip*", "Mint Oreo*", 
            "Nutella", "Oreo", "Peach", "Peanut Butter", "Pineapple", "Raspberry Lemon*", 
            "Raspberry Lime*", "Reese's PB Cup", "Fresh Strawberry", "Strawberry Banana*",
            "Bear Whip - Pineapple Dole Soft Serve, Vanilla Ice Cream, Raspberry"
          ]
        }
      ],
      additionalInfo: '*SPECIALTY FLAVOR EXTRA CHARGE, EXTRA FLAVORS: 55¢ EACH'
    },
    {
      id: 7,
      name: 'Soft Serve',
      description: '',
      items: [
        { id: 1, name: 'Pineapple Dole Soft Serve', description: '', price: '$5.99', image: '' },
      ],
    },
    // {
    //   id: 8,
    //   name: 'Bear Whip',
    //   description: 'Pineapple Dole Soft Serve, Vanilla Ice Cream, Raspberry',
    //   items: [
    //     { id: 1, name: 'Small', description: '', price: '$5.99', image: '' },
    //     { id: 2, name: 'Regular', description: '', price: '$6.99', image: '' },
    //   ],
    // },
    {
      id: 9,
      name: 'Sodas',
      description: 'NO REFILLS',
      items: [
        { id: 1, name: '24 oz.', description: '', price: '$2.25', image: '/images/menu/sodas-300x300.jpg' },
        { id: 2, name: '32 oz.', description: '', price: '$2.79', image: '/images/menu/sodas-300x300.jpg' },
        { id: 3, name: '44 oz.', description: '', price: '$3.25', image: '/images/menu/sodas-300x300.jpg' },
        { id: 4, name: 'Water Bottles', description: '', price: '$1.00', image: '/images/menu/water-300x300.jpg' }
      ],
      flavors: [
       {
          name: 'Available Flavors',
          options: [
            { name: 'Coca-Cola', img: '/images/menu/soda-logos/Coca-Cola.png' },
            { name: 'Diet Coke', img: '/images/menu/soda-logos/Diet_Coke.png' },
            { name: 'Coke Zero', img: '/images/menu/soda-logos/Coca-Cola_zero.png' },
            { name: 'Pepsi', img: '/images/menu/soda-logos/Pepsi.png' },
            { name: 'Diet Pepsi', img: '/images/menu/soda-logos/Diet_Pepsi.png' },
            { name: 'Mtn Dew', img: '/images/menu/soda-logos/Mtn_Dew.png' },
            { name: 'Diet Mtn Dew', img: '/images/menu/soda-logos/diet_Mtn_Dew.png' },
            { name: 'Mtn Dew Zero', img: '/images/menu/soda-logos/Mtn_Dew_zero.png' },
            { name: 'Mtn Dew Voltage', img: '/images/menu/soda-logos/Mtn_Dew_Voltage.png' },
            { name: 'Dr Pepper', img: '/images/menu/soda-logos/Dr_Pepper.png' },
            { name: 'Dr Pepper Zero', img: '/images/menu/soda-logos/Dr_Pepper_zero.png' },
            { name: 'Dr Pepper Blackberry', img: '/images/menu/soda-logos/Dr_Pepper_Blackberry.png' },
            { name: '7-Up', img: '/images/menu/soda-logos/7up.png' },
            { name: 'Squirt', img: '/images/menu/soda-logos/Squirt.png' },
            { name: 'Mug Root Beer', img: '/images/menu/soda-logos/Mug_Root_Beer.png' },
            { name: 'Tropicana Lemonade', img: '/images/menu/soda-logos/Tropicana_lemonade.png' },
            { name: 'Powerade', img: '/images/menu/soda-logos/Powerade.png' },
            { name: 'Fanta Orange', img: '/images/menu/soda-logos/Fanta_orange.png' },
            { name: 'Sierra Mist Zero Sugar', img: '/images/menu/soda-logos/Sierra_Mist_Zero.png' }
          ]
        }
      ]
      },
    
  ];